module.exports = __webpack_public_path__ + "img/avatar-active.38a77e14.svg";